import React, { useEffect, useState } from 'react';
import { Image, Text, View } from '@applane/react-core-components';
import { changePassword } from '../../AppServices';

import { closeIcon, eyeCloseIcon, eyeOpenIcon } from '../../images';

const theme = {
  boxToHoldEverything: {
    // border: '1px solid red',
    width: 300,
    height: 500,
    margin: 'auto',
    // maxWidth: 500,
    // maxHeight: 600,
    borderRadius: 5,
    padding: '10px 0px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderRadius: 20,
    backgroundColor: 'white',
  },

  boxToHoldForm: {
    display: 'flex',
    flexDirection: 'column',
    width: '90%',
    padding: '20px 0px',
    marginBottom: 50,
  },

  boxToHoldLabel: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },

  labelBox: {
    width: 300,
    fontSize: '16px',
  },

  flexBoxToHoldFieldAndIcon: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    height: 35,
    marginBottom: 20,
  },

  boxToHoldField: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    height: 'inherit',
    width: 270,
  },

  boxToHoldEye: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    width: 30,
    height: 'inherit',
    borderTop: '1px solid grey',
    borderRight: '1px solid grey',
    borderBottom: '1px solid grey',
    borderLeft: '0px',
  },

  eyeProperties: {
    width: 15,
    height: 15,
  },

  fieldProperties: {
    borderTop: '1px solid grey',
    borderRight: '0px',
    borderBottom: '1px solid grey',
    borderLeft: '1px solid grey',
    width: 'inherit',
    height: 'inherit',
    paddingLeft: 5,
    outline: '0px',
    fontSize: 18,
  },
};

export const PasswordScreenSA = (props) => {
  const [old, setOld] = useState('');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [message, setMessage] = useState('');
  const [pe, setPE] = useState(false);
  const [ce, setCE] = useState(false);
  const [op, setOP] = useState(false);

  const { navigation } = props;

  const handleSubmit = () => {
    if (!password || !confirm || !old) {
      setMessage(`All the fields are required`);
    }

    if (password && confirm && old) {
      if (password !== confirm) {
        setMessage(`Password and confirm password do not match.`);
      } else {
        const validate =
          /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,16}$/.test(
            password,
          );

        if (!validate) {
          if (password.length < 8) {
            setMessage('Password must have minimum 8 characters.');
          } else if (password.length > 16) {
            setMessage('Password should not exceed 16 characters.');
          } else {
            setMessage(
              `Password should contain at least one letter, one number and one special character.`,
            );
          }
        } else {
          let toPass = {
            newPassword: password,
            confirmPassword: confirm,
            user: { username: 'superadmin' },
            oldPassword: old,
          };

          changePassword(toPass).then((res) => {
            console.log('response of changing password->', res);
            // navigation.pop();
            if (!res.error) {
              navigation.pop();
            }
          });
        }
      }
    }
  };

  return (
    <>
      <div style={theme.boxToHoldEverything}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row-reverse',
            alignItems: 'center',
            width: '95%',
          }}>
          <Image
            source={closeIcon}
            style={{ cursor: 'pointer', marginTop: 5 }}
            onClick={() => {
              navigation.pop();
            }}
          />
        </div>

        <div style={theme.boxToHoldForm}>
          <form>
            <label style={theme.boxToHoldLabel}>
              <div style={theme.labelBox}>Old Password</div>
            </label>
            <div style={theme.flexBoxToHoldFieldAndIcon}>
              <div style={theme.boxToHoldField}>
                <input
                  style={theme.fieldProperties}
                  type={op ? 'text' : 'password'}
                  value={old}
                  placeholder="Enter old password"
                  onChange={(e) => {
                    setOld(e.target.value);
                  }}
                />
              </div>
              <div style={theme.boxToHoldEye}>
                <Image
                  style={theme.eyeProperties}
                  source={op ? eyeOpenIcon : eyeCloseIcon}
                  onClick={() => {
                    setOP(!op);
                  }}
                />
              </div>
            </div>

            <label style={theme.boxToHoldLabel}>
              <div style={theme.labelBox}>Password</div>
            </label>
            <div style={theme.flexBoxToHoldFieldAndIcon}>
              <div style={theme.boxToHoldField}>
                <input
                  style={theme.fieldProperties}
                  type={pe ? 'text' : 'password'}
                  value={password}
                  placeholder="Enter new password"
                  onChange={(e) => {
                    setPassword(e.target.value);
                  }}
                />
              </div>
              <div style={theme.boxToHoldEye}>
                <Image
                  style={theme.eyeProperties}
                  source={pe ? eyeOpenIcon : eyeCloseIcon}
                  onClick={() => {
                    setPE(!pe);
                  }}
                />
              </div>
            </div>

            <label style={theme.boxToHoldLabel}>
              <div style={theme.labelBox}>Confirm Password</div>
            </label>
            <div style={theme.flexBoxToHoldFieldAndIcon}>
              <div style={theme.boxToHoldField}>
                <input
                  style={theme.fieldProperties}
                  type={ce ? 'text' : 'password'}
                  value={confirm}
                  placeholder="Re-enter password"
                  onChange={(e) => {
                    setConfirm(e.target.value);
                  }}
                />
              </div>
              <div style={theme.boxToHoldEye}>
                <Image
                  source={ce ? eyeOpenIcon : eyeCloseIcon}
                  style={theme.eyeProperties}
                  onClick={() => {
                    setCE(!ce);
                  }}
                />
              </div>
            </div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                marginTop: 30,
              }}>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'center',
                  width: 400,
                }}>
                <input
                  onClick={handleSubmit}
                  type="button"
                  value="Save"
                  style={{
                    width: 100,
                    height: 35,
                    backgroundColor: 'black',
                    color: 'white',
                    fontSize: '18px',
                    borderRadius: 20,
                  }}
                />
              </div>
            </div>
          </form>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'center',
              alignItems: 'center',
              margin: '20px 0px',
            }}>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                width: '90%',
                justifyContent: 'center',
                alignItems: 'center',
              }}>
              <i style={{ color: 'red', fontSize: 20, textAlign: 'center' }}>
                {message}
              </i>
            </div>
          </div>

          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'center',
              alignItems: 'center',
              margin: '10px 0px',
            }}>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                width: '90%',
                padding: '15px 0px',
                fontSize: 20,
              }}>
              <i style={{ color: 'grey', textAlign: 'center' }}>
                Password must have 8-16 characters. It should contain at least
                one letter, one number and one special character.
              </i>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
